export default __webpack_public_path__ + "static/media/PaginaWeb-orange.9fbf8277.svg";